import { useWidgetData } from '../../widget/useWidgetData'

import { NextSessionWidget } from '../../../types/widget/widget'

export const useNextSessionWidget = () =>
  useWidgetData<NextSessionWidget>('next-session')
